import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

// The runtime highlight `useHighlightForm` puts on the element carrying the field's `name`. On the
// `root` slot deliberately: the `input` slot would newly highlight affix-wrapped inputs too.
const rootStyle = css`
  &.highlight {
    background-color: #f5f8ff;
    border: 1px solid ${colors['@primary-color-dark']};
  }
`;

const inputConfig: ConfigProviderProps['input'] = { classNames: { root: rootStyle } };

export default inputConfig;
